import { render, staticRenderFns } from "./index.vue?vue&type=template&id=56ee07e3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=56ee07e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee07e3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JoinUsTab: require('D:/Project/kpwebsite/PC/components/joinUs/tab.vue').default,JoinUsWorkJobList: require('D:/Project/kpwebsite/PC/components/joinUs/work-job-list.vue').default})
